// extracted by mini-css-extract-plugin
export default {"container":"ngbcrvqOdURD8Se44Gy6"};